import React from 'react';
import theme from '../../../../theme';
import { CheckIcon } from '../../../../components/icons';
import { Container, Line, MarkerRecipient, MarkerResume, MarkerTemplate } from './styles';

type Props = {
    firstComplete?: boolean;
    secondComplete?: boolean;
    thirdComplete?: boolean;
};

const Timeline: React.FC<Props> = ({ firstComplete = false, secondComplete = false, thirdComplete = false }) => {
    return (
        <Container>
            <Line
                $firstComplete={firstComplete}
                $secondComplete={secondComplete}
            />
            <MarkerRecipient
                $filled $outlined={firstComplete}
            >
                <div>
                    {firstComplete ? (
                        <CheckIcon iconColor={theme.primaryColor} />
                    ) :
                        1
                    }
                </div>
                <small>Destinatário</small>
            </MarkerRecipient>
            <MarkerTemplate
                $filled={firstComplete}
                $outlined={secondComplete}
            >
                <div>
                    {secondComplete ? (
                        <CheckIcon iconColor={theme.primaryColor} />
                    ) :
                        2
                    }
                </div>
                <small>Template</small>
            </MarkerTemplate>
            <MarkerResume
                $filled={secondComplete}
                $outlined={thirdComplete}
            >
                <div>
                    {thirdComplete ? (
                        <CheckIcon iconColor={theme.primaryColor} />
                    ) :
                        3
                    }
                </div>
                <small>Resumo</small>
            </MarkerResume>
        </Container>
    );
};

export { Timeline };
